(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-bedarfsrechner"] && !Shopify.designMode) return;
  try {
    (function () {
    function fmtPrice(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
    /* Mengenfeld über dem Warenkorb-Button. Horizon rendert es als <quantity-selector-component>
       mit einem input[name="quantity"] — das ist zugleich das Feld, das das Kaufformular ausliest. */
    function quantityInput(el) {
      var form = el.closest('product-form-component, form[action*="/cart/add"]');
      var scope = form || document;
      return scope.querySelector('quantity-selector-component input[name="quantity"]') ||
             scope.querySelector('input[name="quantity"]');
    }

    function setup(el) {
      if (el.dataset.omnavaReady) return;
      el.dataset.omnavaReady = '1';
      var rollArea = parseFloat(el.dataset.rollArea);
      var stripH = parseFloat(el.dataset.stripHeight);
      var price = parseFloat(el.dataset.price);
      var isPrecut = el.dataset.precut === '1';
      var precutLen = parseFloat(el.dataset.precutLength);
      var rollLength = stripH > 0 ? rollArea / stripH : 0;
      /* Stück pro Pack aus dem Grundpreis: Fläche ÷ (Streifenlänge × Streifenhöhe). */
      var perPack = (precutLen > 0 && stripH > 0) ? Math.max(1, Math.round(rollArea / (precutLen * stripH))) : 1;
      var lenEl = el.querySelector('.omnava-calc__len');
      var hgtEl = el.querySelector('.omnava-calc__hgt');
      var out = el.querySelector('.omnava-calc__result');
      var hint = out.getAttribute('data-hint');

      var qtyEl = quantityInput(el);
      var userOwnsQty = false;   /* sobald der Kunde die Menge selbst anfasst, hält sich der Rechner heraus */
      var writing = false;       /* eigene Schreibvorgänge nicht als Kundeneingabe werten */

      if (qtyEl) {
        var claim = function () { if (!writing) userOwnsQty = true; };
        qtyEl.addEventListener('input', claim);
        qtyEl.addEventListener('change', claim);
        var selector = qtyEl.closest('quantity-selector-component');
        if (selector) selector.addEventListener('click', claim);
      }

      function applyQuantity(n) {
        if (!qtyEl || userOwnsQty || !(n > 0)) return;
        var max = parseInt(qtyEl.getAttribute('max'), 10);
        if (!isNaN(max) && n > max) n = max;
        if (String(n) === qtyEl.value) return;
        writing = true;
        qtyEl.value = String(n);
        qtyEl.dispatchEvent(new Event('input', { bubbles: true }));
        qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
        var selector = qtyEl.closest('quantity-selector-component');
        if (selector && typeof selector.updateButtonStates === 'function') selector.updateButtonStates();
        writing = false;
      }

      function calc() {
        var L = parseFloat((lenEl.value || '').replace(',', '.'));
        var H = parseFloat((hgtEl.value || '').replace(',', '.'));
        if (!(L > 0) || !(H > 0) || !(rollLength > 0)) {
          out.textContent = hint;
          out.classList.add('omnava-calc__result--hint');
          return;
        }
        /* Reihen = Höhe ÷ 20-cm-Masche, abgerundet; Ganzzahl-Rechnung in cm gegen Float-Fehler */
        var rows = Math.max(1, Math.floor(Math.round(H * 100) / 20));
        var units;
        if (isPrecut) {
          units = Math.ceil((rows * Math.ceil(L / precutLen)) / perPack);
        } else {
          units = Math.ceil((rows * L) / rollLength);
        }
        var noun = units === 1 ? el.dataset.one : el.dataset.many;
        var text = el.dataset.prefix + ' ' + units + ' ' + noun;
        if (price > 0) text += ' (≈ ' + fmtPrice(units * price) + ')';
        out.textContent = text;
        out.classList.remove('omnava-calc__result--hint');
        applyQuantity(units);
      }
      lenEl.addEventListener('input', calc);
      hgtEl.addEventListener('input', calc);
      /* Mobil liegen diese Felder im Kaufformular — Enter würde sonst den Warenkorb auslösen. */
      [lenEl, hgtEl].forEach(function (feld) {
        feld.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter') { ev.preventDefault(); feld.blur(); }
        });
      });
      out.classList.add('omnava-calc__result--hint');

      /* Auf- und Zuklappen (nur mobil sichtbar wirksam, das Umschalten selbst ist harmlos). */
      var toggle = el.querySelector('[data-omnava-calc-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var offen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', offen ? 'false' : 'true');
          if (!offen) lenEl.focus({ preventScroll: true });
        });
      }
    }
    /* Mobil wandert der RECHNER in die Kaufzeile — nicht das Mengenfeld heraus.
       Wichtig: das Mengenfeld muss im Formular bleiben. Horizon liest es über
       `productForm.refs.quantitySelector`, und `FormData(form)` braucht es ebenfalls;
       außerhalb des Formulars landete beim Kauf stillschweigend immer Menge 1 im Warenkorb. */
    var mobil = window.matchMedia('(max-width: 749px)');

    function platziereRechner() {
      var calc = document.querySelector('.omnava-calc');
      if (!calc) return;
      var kaufzeile = document.querySelector('.product-form-buttons');
      if (mobil.matches) {
        if (kaufzeile && calc.parentElement !== kaufzeile) {
          if (!calc.dataset.omnavaHeimat) {
            calc.dataset.omnavaHeimat = '1';
            calc.parentElement.dataset.omnavaCalcHeimat = '1';
          }
          kaufzeile.insertBefore(calc, kaufzeile.firstChild);
        }
      } else if (calc.dataset.omnavaHeimat && calc.parentElement === kaufzeile) {
        var heimat = document.querySelector('[data-omnava-calc-heimat]');
        if (heimat) heimat.appendChild(calc);
      }
    }

    function init() {
      document.querySelectorAll('.omnava-calc').forEach(setup);
      platziereRechner();
    }
    mobil.addEventListener('change', platziereRechner);

    /* Horizon tauscht den Kaufbereich bei Variantenwechsel aus — danach neu einsortieren.
       Gedrosselt und auf die Detailspalte begrenzt: der eigene Umzug löst sonst neue
       Mutationen aus und der Beobachter würde sich selbst im Kreis triggern. */
    var geplant = false;
    function planen() {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () { geplant = false; platziereRechner(); });
    }
    var bereich = document.querySelector('.product-details') || document.body;
    new MutationObserver(planen).observe(bereich, { childList: true, subtree: true });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-styles"] && !Shopify.designMode) return;
  try {
    (function () {
    var RAL = {
      '1015': '#E6D2B5', '3005': '#5E2129', '5010': '#0E294B',
      '6005': '#2F4538', '6009': '#27352A', '6021': '#89AC76',
      '7016': '#383E42', '7030': '#939388', '7035': '#D7D7D7',
      '7038': '#B5B0A1', '7040': '#9DA3A6', '8011': '#5B3A29',
      '8017': '#45322E', '9003': '#F4F4F4', '9005': '#0A0A0A', '9010': '#F1ECE1'
    };
    // Fallback für Optionswerte OHNE RAL-Code (z. B. Befestigungsclips: "Anthracite").
    // Deckt en/de/fr-Labels ab; Hex angelehnt an die RAL-Pendants der Streifen.
    var NAMES = {
      'anthracite': '#383E42', 'anthrazit': '#383E42',
      'brown': '#5B3A29', 'braun': '#5B3A29', 'marron': '#5B3A29',
      'green': '#2F4538', 'grün': '#2F4538', 'vert': '#2F4538',
      'white': '#F4F4F4', 'weiß': '#F4F4F4', 'blanc': '#F4F4F4',
      'light grey': '#9DA3A6', 'light gray': '#9DA3A6', 'hellgrau': '#9DA3A6', 'gris clair': '#9DA3A6',
      'light ivory': '#E6D2B5', 'hellelfenbein': '#E6D2B5', 'ivoire clair': '#E6D2B5',
      'dark grey': '#4A4F54', 'dark gray': '#4A4F54', 'dunkelgrau': '#4A4F54', 'gris foncé': '#4A4F54',
      'black': '#0A0A0A', 'schwarz': '#0A0A0A', 'noir': '#0A0A0A',
      'stone grey': '#939388', 'steingrau': '#939388', 'gris pierre': '#939388'
    };

    function decorate() {
      document.querySelectorAll('.variant-option--buttons .variant-option__button-label').forEach(function (lab) {
        if (!lab.querySelector('.omnava-swatch-dot')) {
          var m = (lab.textContent || '').match(/RAL\s*(\d{4})/);
          var hex = m && RAL[m[1]];
          if (!hex) hex = NAMES[(lab.textContent || '').trim().toLowerCase()];
          if (hex) {
            var dot = document.createElement('span');
            dot.className = 'omnava-swatch-dot';
            dot.style.background = hex;
            dot.setAttribute('aria-hidden', 'true');
            lab.insertBefore(dot, lab.firstChild);
          }
        }
        var t = lab.querySelector('.variant-option__button-label__text');
        if (t && !t.querySelector('.omnava-ral-code')) {
          var mm = (t.textContent || '').trim().match(/^(RAL\s*\d{4})\s+(.+)$/);
          if (mm) {
            t.innerHTML = '<span class="omnava-ral-code">' + mm[1] + '</span> <span class="omnava-ral-name">' + mm[2] + '</span>';
          }
        }
      });
      checkWrap();
    }

    // Einheitlicher Umbruch: brechen ohne force-wrap manche Labels um (ungleiche Höhen),
    // wird der Umbruch für ALLE erzwungen → konsistente Optik. Passt alles in eine Zeile,
    // bleiben alle einzeilig. Höhenbasiert (robuster als scrollWidth bei flex min-width:auto).
    function checkWrap() {
      var fs = document.querySelector('.variant-option--buttons');
      if (!fs) return;
      fs.classList.remove('omnava-force-wrap');
      var labels = fs.querySelectorAll('.variant-option__button-label');
      if (!labels.length) return;
      var heights = Array.prototype.map.call(labels, function (l) { return l.offsetHeight; });
      var uneven = Math.max.apply(null, heights) - Math.min.apply(null, heights) > 4;
      if (uneven) fs.classList.add('omnava-force-wrap');
    }

    // 7 — Desktop-Sticky: Offset unter dem (sticky) Header messen — shop-neutral.
    // Achtung: die Header-Gruppe enthält mehrere Sections (Announcement + Header);
    // relevant ist die STICKY-Section, nicht die erste.
    function stickyHeaderEl() {
      var els = document.querySelectorAll('.shopify-section-group-header-group, header.shopify-section');
      for (var i = 0; i < els.length; i++) {
        if (getComputedStyle(els[i]).position === 'sticky') return els[i];
      }
      return null;
    }
    function setStickyOffset() {
      var header = stickyHeaderEl();
      var h = header ? header.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--omnava-sticky-top', (h + 16) + 'px');
    }

    // 8 — Mobile-Mini-Vorschau: erscheint, sobald die Galerie nach oben rausgescrollt ist
    function setupMini(gal) {
      if (document.querySelector('.omnava-mini-gallery')) return;
      var getMain = function () { return gal.querySelector('.omnava-app-gallery__main img'); };
      if (!getMain()) return;
      var bar = document.createElement('div');
      bar.className = 'omnava-mini-gallery';
      var im = document.createElement('img');
      im.className = 'omnava-mini-gallery__img';
      im.alt = '';
      var title = document.createElement('span');
      title.className = 'omnava-mini-gallery__title';
      var h1 = document.querySelector('h1');
      title.textContent = h1 ? h1.textContent.trim() : '';
      var price = document.createElement('span');
      price.className = 'omnava-mini-gallery__price';
      var priceEl = document.querySelector('.price');
      price.textContent = priceEl ? priceEl.textContent.trim().split('\n')[0] : '';
      bar.appendChild(im);
      bar.appendChild(title);
      bar.appendChild(price);
      document.body.appendChild(bar);

      function syncImg() {
        var m = getMain();
        if (m && m.src && im.src !== m.src) {
          im.src = m.src;
          im.classList.remove('omnava-pulse');
          void im.offsetWidth; /* Animation neu triggern */
          im.classList.add('omnava-pulse');
        }
      }
      syncImg();
      new MutationObserver(syncImg).observe(gal, { subtree: true, childList: true, attributes: true, attributeFilter: ['src'] });

      function positionBar() {
        var header = stickyHeaderEl();
        var bottom = header ? header.getBoundingClientRect().bottom : 0;
        document.documentElement.style.setProperty('--omnava-mini-top', Math.max(0, bottom) + 'px');
      }
      // Hysterese gegen Doppelung: EINblenden erst, wenn die Galerie komplett aus dem
      // Sichtbereich gescrollt ist; AUSblenden schon, sobald sie beim Hochscrollen
      // wieder zur Hälfte sichtbar ist. Dazwischen bleibt der Zustand stehen.
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          if (!e.isIntersecting && e.boundingClientRect.bottom <= 0) {
            positionBar();
            bar.classList.add('is-visible');
          } else if (e.intersectionRatio >= 0.5) {
            bar.classList.remove('is-visible');
          }
        }, { threshold: [0, 0.5] }).observe(gal);
      }
      bar.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    // 9 — Mobile-Aktionsleiste: echte Kaufelemente unten fixieren, sobald vorbeigescrollt.
    // Spacer hält die Dokumenthöhe stabil; unfixen, sobald der Bereich wieder sichtbar wird.
    // Selbstheilend: Horizon morpht die Kaufbox nach dem Initial-Render (Knoten wird
    // ersetzt) → MutationObserver richtet Spacer + Observer dann neu ein.
    function setupBuybar() {
      var details = document.querySelector('.product-details');
      if (!details) return;

      function ensure() {
        var wrap = details.querySelector('.product-form-buttons');
        if (!wrap || wrap.dataset.omnavaBuybar) return;
        wrap.dataset.omnavaBuybar = '1';
        var section = wrap.closest('.shopify-section');
        if (section) section.classList.add('omnava-elevate');
        var old = details.querySelectorAll('.omnava-buybar-spacer');
        for (var i = 0; i < old.length; i++) old[i].remove();
        var spacer = document.createElement('div');
        spacer.className = 'omnava-buybar-spacer';
        wrap.parentNode.insertBefore(spacer, wrap);
        function setFixed(on) {
          if (on === wrap.classList.contains('omnava-buybar-fixed')) return;
          if (on) {
            spacer.style.height = wrap.getBoundingClientRect().height + 'px';
            wrap.classList.add('omnava-buybar-fixed');
          } else {
            wrap.classList.remove('omnava-buybar-fixed');
            spacer.style.height = '0px';
          }
        }
        // Scroll+rAF statt IntersectionObserver: Horizons DOM-Morphing killt IO-Events
        // sporadisch. Referenz: unfixiert → Unterkante der Kaufbox selbst; fixiert →
        // der Spacer (hält die natürliche Position). Gleiche Grenze in beide Richtungen.
        var ticking = false;
        function onScroll() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            if (!spacer.isConnected || !wrap.isConnected) {
              window.removeEventListener('scroll', onScroll);
              return;
            }
            var refEl = wrap.classList.contains('omnava-buybar-fixed') ? spacer : wrap;
            setFixed(refEl.getBoundingClientRect().bottom <= 0);
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      ensure();
      if (window.MutationObserver) {
        new MutationObserver(function () { ensure(); }).observe(details, { childList: true, subtree: true });
      }
    }

    function whenGallery(cb) {
      var tries = 0;
      (function poll() {
        var gal = document.querySelector('.omnava-app-gallery');
        if (gal) { cb(gal); return; }
        if (tries++ > 40) return;
        setTimeout(poll, 250);
      })();
    }

    function preloadGallery(gal) {
      var seen = {};
      gal.querySelectorAll('.omnava-app-gallery__thumbs img').forEach(function (img) {
        var s = img.getAttribute('src');
        if (!s) return;
        var big = s.replace(/width=\d+/, 'width=1600');
        if (seen[big]) return;
        seen[big] = 1;
        var pre = new Image();
        pre.src = big.indexOf('//') === 0 ? location.protocol + big : big;
      });
    }

    function enableSwipe(gal) {
      var main = gal.querySelector('.omnava-app-gallery__main');
      if (!main || main.dataset.omnavaSwipe) return;
      main.dataset.omnavaSwipe = '1';
      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 40) return;
        var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.omnava-app-gallery__thumbs button'));
        if (!thumbs.length) return;
        var cur = ((main.querySelector('img') || {}).src || '').replace(/width=\d+/, '');
        var idx = thumbs.findIndex(function (b) {
          var ti = b.querySelector('img');
          return ti && ti.src.replace(/width=\d+/, '') === cur;
        });
        if (idx < 0) idx = 0;
        var next = dx < 0 ? idx + 1 : idx - 1;
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        thumbs[next].click();
      }, { passive: true });
    }

    function init() {
      decorate();
      var picker = document.querySelector('variant-picker');
      if (picker && window.MutationObserver) {
        new MutationObserver(function () { decorate(); }).observe(picker, { childList: true, subtree: true });
      }
      var fs = document.querySelector('.variant-option--buttons');
      if (fs && window.ResizeObserver) {
        var lastW = 0;
        new ResizeObserver(function () {
          var w = fs.clientWidth;
          if (w !== lastW) { lastW = w; checkWrap(); }
        }).observe(fs);
      }
      setStickyOffset();
      window.addEventListener('resize', setStickyOffset);
      setupBuybar();
      whenGallery(function (gal) { preloadGallery(gal); enableSwipe(gal); setupMini(gal); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
